import { useAxios } from '@/hooks/useAxios';
import { useAuth } from '@/state/auth';
import { UniqueQueryKeys } from '@/types';
import { useQuery } from '@/utils/api';

export function useSSOId({ email }: { email?: string } = {}) {
  const { friend, me } = useAuth();
  const currentEmail = email || friend || me;
  const axios = useAxios({ email: currentEmail });

  return useQuery<{ sso_id: string }>({
    defaultErrorMessage: 'Failed to fetch SSO verification ID',
    queryKey: [UniqueQueryKeys.SSO_ID, currentEmail],
    queryFn: async () => {
      const res = await axios.get('/sso-id');
      return res.data;
    },
    staleTime: 30000,
    gcTime: 300000,
  });
}
